package com.appsyde.shared

import kotlinx.browser.window
import kotlinx.browser.localStorage

private const val ACCESS_TOKEN_KEY = "appsyde_access_token"

actual fun backendBaseUrl(): String = getBackendUrl()

fun getBackendUrl(): String {
    val host = window.location.hostname
    return if (host == "localhost" || host == "127.0.0.1") {
        "http://127.0.0.1:8081"
    } else {
        "https://appsyde-api.fly.dev"
    }
}

actual fun appToken(): String = "455"

actual fun getAccessToken(): String? =
    try { localStorage.getItem(ACCESS_TOKEN_KEY)?.takeIf { it.isNotBlank() } } catch (_: Throwable) { null }

actual fun setAccessToken(token: String?) {
    try {
        if (token.isNullOrBlank()) localStorage.removeItem(ACCESS_TOKEN_KEY)
        else localStorage.setItem(ACCESS_TOKEN_KEY, token)
    } catch (_: Throwable) {}
}

actual fun clearAccessToken() = setAccessToken(null)

private const val ACCOUNT_ID_KEY = "accountId"

/** À appeler au logout : supprime le token et accountId pour éviter d’être « reconnecté » au refresh. */
fun clearSessionForLogout() {
    clearAccessToken()
    try {
        localStorage.removeItem(ACCOUNT_ID_KEY)
    } catch (_: Throwable) {}
}
